import DetailsDialog from './DetailsDialog';

export default function Dialog() {
  return (
    <>
      <DetailsDialog />
    </>
  );
}
